import Cookies from "js-cookie";

const BrandKey = "User-Brand"
const tokenKey = 'Access-Token'

// 获取公司标识
export function getBrand() {
    return Cookies.get(BrandKey)
}

// 保存公司标识
export function setBrand(brand) {
    Cookies.set(BrandKey, brand, { expires: 1 })
}

// 移除公司标识
export function removeBrand() {
    Cookies.remove(BrandKey)
}

// 获取令牌
export function getToken() {
    return Cookies.get(tokenKey)
}

// 设置令牌
export function setToken(token) {
    Cookies.set(tokenKey, token, { expires: 1 })
}

// 移除令牌
export function removeToken() {
    Cookies.remove(tokenKey)
}